import React, { Component } from "react";
export default class Resume extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="resume">
        <div className="row speaking">
          <div className="three columns header-col">
            <h1><span>Speaking</span></h1>
          </div>
          <div className="nine columns main-col">
            {resumeData.speaking &&
              resumeData.speaking.map(item => {
                return (
                  <div className="row item">
                    <div className="twelve columns">
                      <a
                        href={`${item.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <h3>{item.name}</h3>
                      </a>
                      <p className="info">
                     {"Prevent Embarrassing Cluster Takeovers with This One Simple Trick"}
                        <span>&bull;</span>{" "}
                        <em className="date">
                          {item.MonthOfPassing} {item.YearOfPassing}
                        </em>
                      </p>
                      <p>{item.description}</p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="row education">
          <div className="three columns header-col">
            <h1>
              <span>Education</span>
            </h1>
          </div>
          <div className="nine columns main-col">
            {resumeData.education &&
              resumeData.education.map(item => {
                return (
                  <div className="row item">
                    <div className="twelve columns">
                      <a
                        href={`${item.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <h3>{item.UniversityName}</h3>
                      </a>
                      <p className="info">
                        {item.specialization}
                        <span>&bull;</span>{" "}
                        <em className="date">
                          {item.MonthOfPassing} - {item.YearOfPassing}
                        </em>
                      </p>
                      <p>{item.Achievements}</p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Work</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            {resumeData.work &&
              resumeData.work.map(item => {
                return (
                  <div className="row item">
                    <div className="twelve columns">
                      <h3>
                        <a
                          href={`${item.link}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.CompanyName}
                        </a>
                      </h3>
                      <p className="info">
                        {item.specialization}
                        <span>&bull;</span>{" "}
                        <em className="date">
                          {item.MonthOfLeaving} - {item.YearOfLeaving}
                        </em>
                      </p>
                      <p>{item.Achievements}</p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
    );
  }
}
